import { Injectable, inject } from '@angular/core';

import { Router } from '@angular/router';

import { UserRole } from '../constants/user-role';
import { HandlePermissions } from '../functions/handle-permissions';

@Injectable()
export class AuthGuard  {
  private router = inject(Router);
  private readonly handlePermissions = inject(HandlePermissions);

  canActivate() {

    if (this.checkIsCorrespondentUser()) {
      this.router.navigate(['messages-overview']);
      return false;
    }
    return true;
  }

  private checkIsCorrespondentUser(): boolean {
    const roles = this.handlePermissions.getRoles();
    const result = roles?.find((role) => role === UserRole.correspondentUser);
    if (result !== undefined) return true;
    return false;
  }
}
